"use strict";
exports.__esModule = true;
exports.startNewSession = exports.getSessionProperties = void 0;
var logger_1 = require("../logger");
var strings_1 = require("./../util/strings");
var log = (0, logger_1.getLogger)("session");
var sessionProperties;
function getSessionProperties() {
    if (sessionProperties === undefined) {
        startNewSession("COLD");
    }
    return sessionProperties;
}
exports.getSessionProperties = getSessionProperties;
function startNewSession(appStartupType) {
    var props = {
        sessionId: (0, strings_1.generateBase64UUId)(),
        appStartupType: appStartupType
    };
    log.debug("Started new Blizzard session:", props);
    sessionProperties = props;
}
exports.startNewSession = startNewSession;
//# sourceMappingURL=session.js.map